/**
 * Fetch data from API and return the response as JSON
 *
 * @param {string} endPoint - The endpoint of the API
 * @param {object} [body=null] - The body of the request
 * @param {string} [method='GET'] - The method of the request
 * @return {Promise<Object>} The response data as JSON
 */
export const getApiData = async ( endPoint, body = null, method = 'GET' ) => {
    const baseURL   = (<any>window).ssb.cdn_url;
    const URL       = baseURL + endPoint;

    const response = await fetch( URL, {
        method: method,
        body: body,
        headers: {
            'Content-Type': 'application/json'
        }
    } );

    return await response.json();
}